/* eslint-disable react/no-danger */
import { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { ArrowLink, ExpandableLink, CloudinaryPicture } from '@bwoty-web/ui-kit';
import queryHelper from '../../../../../utils/url/queryHelper';

import './roomContent.scss';

const RoomContent = ({ content, texts, toggleRoomInfo, tabsExist }) => {
  const [openConceptIds, setOpenConceptIds] = useState(
    decodeURIComponent(queryHelper.getQueryKeyValue('conceptIds'))?.split(
      ',',
    ) || [],
  );
  
  if (!content || !content.roomConcepts) {
    return false;
  }
  const isConceptIdOpen = (conceptId) => {
    return openConceptIds.indexOf(`${conceptId}`) >= 0;
  };

  const toggleConcept = (conceptId) => {
    let updatedConceptIds = [];
    if (isConceptIdOpen(conceptId)) {
      updatedConceptIds = openConceptIds.filter((c) => c !== `${conceptId}`);
      setOpenConceptIds(updatedConceptIds);
    } else {
      updatedConceptIds = [...openConceptIds, `${conceptId}`];
      setOpenConceptIds(updatedConceptIds);
    }
    queryHelper.updateQueryWithValues({
      conceptIds: updatedConceptIds.length
        ? updatedConceptIds.join(',')
        : '',
    });
  };

  const roomViewClasses = classnames({ 'gw-room-view': tabsExist });

  return (
    <div className={roomViewClasses}>
      {content.intro && (
        <div className="gw-room-view__intro">
          <span dangerouslySetInnerHTML={{ __html: content.intro }} />
        </div>
      )}
      {(content.roomConcepts || []).map((concept) => (
        <div className="gw-room-view__concept" key={concept.id}>
          <div className="gw-room-view__concept-image">
            <CloudinaryPicture
              key={concept.id}
              img={concept.picture}
              sizes={[
                {
                  width: 300,
                  brekpoint: 768,
                },
                {
                  width: 500,
                  brekpoint: 415,
                },
                {
                  width: 415,
                },
              ]}
              className="gw-room-view__concept-image-source"
              alt={concept.picture?.alt}
              lazy
              retina
            />
          </div>
          <div className="gw-room-view__content">
            {concept.name && (
              <h3 className="gw-room-view__content-header">{concept.name}</h3>
            )}
            <p>{concept?.texts?.description}</p>
            <div
              className={classnames('gw-room-view__content-rooms', {
                'gw-room-view__content-rooms--hidden': !isConceptIdOpen(
                  concept.id,
                ),
              })}
            >
              {concept.roomTypes.map((roomType) => (
                <div className="gw-room-view__room" key={roomType.id}>
                  <ArrowLink
                    onClick={() => toggleRoomInfo(roomType.id)}
                    gtm="Accom Room type"
                    className="gw-room-view__room-link"
                  >
                    {roomType.name}
                  </ArrowLink>
                  {roomType.part && (
                    <span className="gw-room-view__room-building">
                      {roomType.part}
                    </span>
                  )}
                </div>
              ))}
            </div>
            <ExpandableLink
              className="gw-room-view__content-expand"
              gtm="Accom Room category"
              onClick={() => toggleConcept(concept.id)}
              isOpen={isConceptIdOpen(concept.id)}
            >
              {isConceptIdOpen(concept.id) ? texts.hideRooms : texts.showRooms}
            </ExpandableLink>
          </div>
        </div>
      ))}
    </div>
  );
};

RoomContent.propTypes = {
  content: PropTypes.shape({
    heading: PropTypes.string,
    intro: PropTypes.string,
    __typename: PropTypes.string,
    roomConcepts: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        picture: PropTypes.shape({
          fallback: PropTypes.shape({}),
          sources: PropTypes.arrayOf(PropTypes.shape({})),
          text: PropTypes.string,
        }),
        roomTypes: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            part: PropTypes.string,
          }),
        ),
      }),
    ),
  }).isRequired,
  texts: PropTypes.shape({
    hideRooms: PropTypes.string,
    showRooms: PropTypes.string,
    roomTypePopupPlacementHeading: PropTypes.string,
    roomTypePopupShowLess: PropTypes.string,
    roomTypePopupShowMore: PropTypes.string,
  }).isRequired,
  toggleRoomInfo: PropTypes.func.isRequired,
  tabsExist: PropTypes.bool.isRequired,
};

export default RoomContent;
